import script from "./user-title.vue?vue&type=script&setup=true&lang=js"
export * from "./user-title.vue?vue&type=script&setup=true&lang=js"

import "./user-title.vue?vue&type=style&index=0&id=45b21934&scoped=true&lang=css"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b21934"]])

export default __exports__